import { AlertStyle } from '../../alert/Alert'
import { ButtonStyle } from '../../button/Button'
import { CloseButtonStyle } from '../../close-button/CloseButton'
import { DrawerStyle } from '../../drawer/Drawer'
import { ListStyle } from '../../list/List'
import { menuStyle } from '../../menu/Menu'
import { TabStyle } from '../../tab/Tab'
import { TagStyle } from '../../tag/Tag'
import { TextStyle } from '../../text/Text'
import { TooltipStyle } from '../../tooltip/Tooltip'

export const componentsStyles = {
  components: {
    Text: TextStyle,
    Button: ButtonStyle,
    List: ListStyle,
    Menu: menuStyle,
    Tag: TagStyle,
    Tooltip: TooltipStyle,
    Drawer: DrawerStyle,
    Alert: AlertStyle,
    CloseButton: CloseButtonStyle,
    Tabs: TabStyle,
  },
}
